<template>
  <div>
    <doe-label :name="name" :required="fieldRequired">
      {{ label }}
    </doe-label>
    <span v-if="prefix" class="absolute border-gray-800 border-r font-sans leading-snug py-2 subpixel-antialiased font-bold text-center text-black text-xl max-w-xs w-full">{{ prefix }}</span>
    <input
      :disabled="disabled || dynamicDisabledVal"
      autocomplete="off"
      :type="type"
      :key="name"
      :name="name"
      :id="name"
      :placeholder="placeholder"
      v-validate="validationRules"
      :data-vv-as="label"
      :class="{ hasError: errors.has(name), hasPrefix: prefix, 'max-w-3xl': this.type === 'email', 'max-w-2xl': this.type !== 'email'  }"
      :aria-describedby="generateAriaDescription(name)"
      v-model="inputVal"
      maxlength="80"
    />
    <doe-error v-if="errors.has(name)" :description="ariaErrorDescID(name)">{{ errors.first(name) }}</doe-error>
    <doe-hint :hint="hint" :description="ariaDescID(name)" />
  </div>
</template>

<script>
import dynamicValues from "@/mixins/dynamicValues";

import DoeLabel from "@/components/field/Label";
import DoeHint from "@/components/field/Hint";
import DoeError from "@/components/field/Error";

export default {
  name: "DoeText",
  inject: {
    $validator: "$validator"
  },
  mixins: [dynamicValues],
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dynamicDisable: {
      type: [Boolean, Function],
      default: false
    },
    fieldRequired: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String
    },
    type: {
      type: String,
      default: "text",
      validator: value => {
        return ["text", "password", "number", "email"].indexOf(value) !== -1;
      }
    },
    validation: {
      type: [Object, String, Function]
    },
    placeholder: {
      type: String
    },
    hint: {
      type: [Array, String]
    }
  },
  components: {
    DoeLabel,
    DoeHint,
    DoeError
  },
  computed:{
    inputVal:{
      get(){
        return this.value;
      },
      set(val){
        this.$emit('input', val)
      }
    },
    validationRules(){
      return this.getRequiredValue(this.validation);
    },
    dynamicDisabledVal(){
      return this.getDisabledValue(this.dynamicDisable);
    }
  },
  methods: {
    generateAriaDescription(fieldName) {
      if (this.errors.has(fieldName)) {
        return this.ariaErrorDescID(fieldName);
      }
      if (this.hint) {
        return this.ariaDescID(fieldName);
      }
      return false;
    },
    ariaDescID(fieldName) {
      return `${fieldName}Description`;
    },
    ariaErrorDescID(fieldName) {
      return `${fieldName}ErrorDescription`;
    }
  }
};
</script>

<style lang="scss" scoped>
input {
  @apply bg-gray-300 border border-gray-800 rounded font-sans leading-snug px-3 py-2 subpixel-antialiased text-gray-900 text-xl w-full;
  &:hover {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
  }
  &:focus {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
    outline: 1px solid #041e42;
    outline-offset: 3px;
  }
}
input.hasPrefix {
  padding-left: 70px;
}
input.hasError {
  border-color: #d0021b;
}
input[type="text"]:disabled {
  @apply bg-gray-500;
  &:hover, &:focus {
    @apply border-gray-900;
    box-shadow: none;
  }
}
</style>
